<template>
  <div class="headers">
    <div class="top">
      <div class="w">
        <div class="l">
          <!-- 欢迎信息 -->
        </div>
        <div class="r">
          <div class="lis2">
            <img src="../assets/img/phone2.png" alt="电话图标" />
            <span>咨询热线：010-66045051</span>
          </div>
          <div class="lis2">
            <img src="../assets/img/phone2.png" alt="电话图标" />
            <span>投诉热线：400-101-8662</span>
          </div>
          
          <!-- 投诉流程（突出样式） -->
          <div class="lis2 complaint-process" @click="openComplaintFlow">
            <span>投诉流程</span>
            <span class="hot-tag">HOT</span>
          </div>
          
          <!-- 一键调解（突出样式） -->
         <div class="lis2 mediation-btn" @click="goMediation">
            <span>一键调解</span>
          </div>
		  <!-- 一键投诉 -->
		 <div class="lis2 complaint-process" @click="complaintFlow">
		    <span>一键投诉</span>
		  </div>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="w">
        <div class="left">
          <img src="../assets/img/index/header/022.png" alt="网站logo" />
        </div>
        <div class="r" id="livst">
          <el-menu style="border-bottom: none; font-weight: 600" text-color="#222222" active-text-color="#d5352e"
            :default-active="$route.name" :router="true" class="el-menu-vertical-demo" mode="horizontal"
            @select="handleSelect">
            <el-menu-item style="margin-right: 20px" index="index" :route="{ path: '/' }">
              首页
            </el-menu-item>
            <el-menu-item style="margin-right: 20px" index="news" :route="{ path: '/news' }">
              新闻资讯
            </el-menu-item>
            <el-menu-item style="margin-right: 20px" index="product" :route="{ path: '/product' }">
              产品中心
            </el-menu-item>
            
            <el-submenu style="margin-right: 20px" index="download">
              <template slot="title">产品下载</template>
              <el-menu-item @click="to_xaizai1()">下载地址一</el-menu-item>
              <el-menu-item @click="to_xaizai2()">下载地址二</el-menu-item>
              <el-menu-item @click="to_xaizai3()">下载地址三</el-menu-item>
              <el-menu-item @click="to_xaizai5()">下载地址五</el-menu-item>
            </el-submenu>
            
            <el-menu-item style="margin-right: 20px" index="userService" :route="{ path: '/userService' }">
              用户服务
            </el-menu-item>
            
            <el-menu-item style="margin-right: 20px" index="aboutUs" :route="{ path: '/aboutUs' }">
              关于我们
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>

    <!-- 投诉流程对话框 -->
    <el-dialog 
      title="投诉处理流程" 
      :visible.sync="dialogVisible" 
      width="80%"
      :close-on-click-modal="false"
      top="5%"
    >
     <!-- 原轮播部分替换为以下内容 -->
     <div class="static-flow-container">
       <!-- 流程步骤1 -->
       <div class="flow-step">
         <h3>投诉流程</h3>
         <div class="flow-content">
           <img src="../assets/img/ts/4.png" alt="" class="flow-img">
         </div>
       </div>
     </div>
       
      </el-carousel>
      
      <div slot="footer" style="text-align: center;">
        <el-button type="primary" @click="dialogVisible = false">我已知晓</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Headers",
  data() {
    return {
      activeIndex: "1",
      tilte: 0,
      dialogVisible: false
    };
  },
  methods: {
    handleSelect(index) {
      this.tilte = index;
    },
		
	complaintFlow(){
	  window.open("https://s.txcfgl.com/toc/#/complaint/complaint-input?channel=GDD_H5");
	},
    to_xaizai1() {
      window.open("https://guduoduo.oss-cn-shenzhen.aliyuncs.com/%E5%AE%89%E8%A3%85%E5%8C%85/GDD1103.exe");
    },
    to_xaizai2() {
      window.open("https://guduoduo.oss-cn-shenzhen.aliyuncs.com/%E5%AE%89%E8%A3%85%E5%8C%85/GDD2015.exe");
    },
    to_xaizai3() {
      window.open("https://guduoduo.oss-cn-shenzhen.aliyuncs.com/%E5%AE%89%E8%A3%85%E5%8C%85/GDD3001.exe");
    },
    to_xaizai5() {
      window.open("https://guduoduo.oss-cn-shenzhen.aliyuncs.com/%E5%AE%89%E8%A3%85%E5%8C%85/GDD5001.exe");
    },
    openComplaintFlow() {
      this.dialogVisible = true;
    },
    goMediation() {
      window.open("http://lsc.isc.com.cn", "_blank");
    }
  }
};
</script>

<style scoped lang="less">
/* 基础样式 */
*{
  font-size: 16px;
}
/* 静态展示容器样式 */
.static-flow-container {
  width: 100%;
  height: 500px; /* 保持原轮播高度 */
  border-radius: 6px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 限制图片最大高度（核心修改） */
.flow-img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  max-height: 400px; /* 固定最大高度 */
  height: auto;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

/* 响应式调整图片高度 */
@media (max-width: 1200px) {
  .static-flow-container {
    height: 550px;
  }
  .flow-img {
    max-height: 450px;
  }
}

@media (max-width: 768px) {
  .static-flow-container {
    height: 350px;
  }
  .flow-img {
    max-height: 280px;
  }
}
.top {
  width: 100%;
  height: 42px;
  background-color: #f3f4f6;

  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #555555;

    .r {
      height: 42px;
      display: flex;
      align-items: center;

      .lis1 {
        img {
          width: 19px;
          height: 16px;
          margin-right: 10px;
        }
        display: flex;
        align-items: center;
      }

      .lis2 {
        margin-left: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s ease;

        img {
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }

        &:hover {
          color: #d5352e;
          transform: translateY(-1px);
        }
      }

      /* 投诉流程突出样式 */
      .complaint-process {
        position: relative;
        font-weight: 700;
        color: #d5352e;
        padding: 0 8px;
        border: 1px solid #ffd7d7;
        border-radius: 4px;
        background-color: rgba(255, 221, 221, 0.2);
        
        /* HOT标识 */
        .hot-tag {
          position: absolute;
          top: -13px;
          right: -13px;
          font-size: 10px;
          font-weight: 800;
          color: #fff;
          background-color: #ff4d4f;
          padding: 1px 4px;
          border-radius: 3px;
          box-shadow: 0 1px 2px rgba(0,0,0,0.1);
        }
        
        &:hover {
          background-color: rgba(255, 221, 221, 0.4);
          border-color: #ffb8b8;
          transform: translateY(-2px);
        }
      }

      /* 一键调解突出样式 */
      .mediation-btn {
        font-weight: 700;
        color: #0a84ff;
        padding: 0 8px;
        border: 1px solid #cce0ff;
        border-radius: 4px;
        background-color: rgba(204, 224, 255, 0.2);
        
        &:hover {
          color: #0066cc;
          background-color: rgba(204, 224, 255, 0.4);
          border-color: #99c2ff;
          transform: translateY(-2px);
        }
      }
    }
  }
}

.nav {
  width: 100%;
  height: 80px;

  .w {
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
   
    .el-menu-demo {
      font-weight: 600;
    }

    .el-menu-item.is-active {
      border-bottom: 3px solid #d5352e;
    }
  }
}

/* 对话框样式 */
::v-deep .el-dialog {
  width: 80% !important;
  max-width: 1200px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(5px);
}

::v-deep .el-dialog__header {
  background-color: transparent;
  padding-top: 20px;
}

::v-deep .el-dialog__title {
  font-size: 18px;
  color: #333;
  font-weight: 600;
  text-align: center;
  width: 100%;
}

::v-deep .el-dialog__body {
  padding: 20px 30px;
  margin: 0;
  background-color: transparent;
}

/* 轮播图核心样式 - 确保居中 */
::v-deep .el-carousel {
  width: 100%;
  height: 500px;
  border-radius: 6px;
  overflow: hidden;
  border: none;
  background-color: rgba(255, 255, 255, 0.9);
}

::v-deep .el-carousel__container {
  height: 100%;
}

/* 关键：确保轮播项内部内容居中 */
::v-deep .el-carousel__item {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100% !important; /* 强制轮播项宽度为100% */
}

::v-deep .el-carousel__indicators--outside {
  margin-top: 15px;
}

/* 轮播内容样式 */
.flow-step {
  width: 100%;
  height: 100%;
  padding: 5px 10px;
  box-sizing: border-box;
  text-align: center; /* 文本居中 */
}

.flow-step h3 {
  font-size: 19px;
  color: #333;
  margin: 0 0 15px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #eee;
  display: inline-block; /* 标题宽度适应内容 */
}

/* 图片容器 - 关键居中样式 */
.flow-content {
  width: 100%;
  height: calc(100% - 45px);
  display: flex;
  flex-direction: column;
  align-items: center; /* 水平居中 */
  justify-content: center; /* 垂直居中 */
  padding: 0 5%;
  box-sizing: border-box;
}

/* 图片样式 - 确保居中显示 */
.flow-img {
  display: block; /* 消除图片底部间隙 */
  margin: 0 auto; /* 水平居中 */
  max-width: 100%; /* 不超过容器宽度 */
  max-height: 100%; /* 不超过容器高度 */
  height: auto; /* 保持比例 */
  object-fit: contain; /* 保持图片完整 */
  border-radius: 4px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.flow-img:hover {
  transform: scale(1.03);
}

/* 按钮样式 */
::v-deep .el-button--primary {
  background-color: #d5352e;
  border-color: #d5352e;
  padding: 8px 30px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover, &:focus {
    background-color: #c2241c;
    border-color: #c2241c;
    transform: translateY(-2px);
  }
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .top .w, .nav .w {
    width: 95%;
  }
  
  ::v-deep .el-dialog {
    width: 90% !important;
  }
  
  ::v-deep .el-carousel {
    height: 450px;
  }
}

@media (max-width: 768px) {
  .top {
    height: auto;
    padding: 10px 0;
    
    .w {
      flex-direction: column;
      gap: 10px;
    }
    
    .r {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
  
  ::v-deep .el-carousel {
    height: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headers.vue